export default __webpack_public_path__ + "static/media/Feature1.64f8336b.svg";